import { Portal, Emissor } from 'enum';
import ReactDOM from 'react-dom';
import { ContentMainType } from 'types';

import App from './app';
import reportWebVitals from './report-web-vitals';

export const ContextElement = document.getElementById('footer');

if (ContextElement) {
  const attributes: any = ContextElement?.attributes || {};
  const props: ContentMainType = {
    emissor: attributes.emissor.value as Emissor,
    portal: attributes.portal ? (attributes.portal.value as Portal) : undefined,
  };

  ReactDOM.render(
    <App emissor={props.emissor} portal={props.portal} />,
    ContextElement,
  );

  reportWebVitals();
}
